import { authStore, useAuth } from '@/lib/auth/auth';
import { dashboardKeys } from '@/features/events/feed/feedQuery';
import type { DashboardResult, PatchProfileRequest, ProfileResponse } from '@/lib/api/apiTypes';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useUpdateProfile() {
  const request = useAuth((state) => state.request);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PatchProfileRequest) =>
      request<ProfileResponse>('/profile', {
        method: 'PATCH',
        body: JSON.stringify(payload),
      }),
    onSuccess: async (data, payload) => {
      queryClient.setQueryData<DashboardResult>(dashboardKeys.current(), (current) =>
        current
          ? {
              ...current,
              profile: {
                ...current.profile,
                ...data.profile,
                default_rsvp_public: payload.default_rsvp_public ?? current.profile.default_rsvp_public,
              },
            }
          : current
      );

      authStore.setState((state) =>
        state.session
          ? {
              ...state,
              session: {
                ...state.session,
                me: {
                  ...state.session.me,
                  profile: {
                    ...state.session.me.profile,
                    ...data.profile,
                  },
                },
              },
            }
          : state
      );

      await queryClient.invalidateQueries({ queryKey: dashboardKeys.current() });
    },
  });
}
